module.exports = __webpack_public_path__ + "static/media/Basket.89b7591b.svg";